import snakeCase from 'lodash/snakeCase';
import type { IEventBridgeAdapter, CustomEvent } from './types';

const EVENT_CATEGORY = 'customEvent';

export class CustomEventAdapter implements IEventBridgeAdapter<CustomEvent> {
	formatEvent = (e: CustomEvent) => {
		const originalEvent: typeof e = {
			type: e.type.includes('.')
				? e.type
						.split('.')
						.map((part, index) => (index === 0 ? part : snakeCase(part)))
						.join('.')
				: snakeCase(e.type),
			details: e.details,
		};
		return {
			category: EVENT_CATEGORY,
			originalEvent,
			timestamp: new Date().toISOString(),
		};
	};
}
